/**
 * @desc 执行请求
 */
const URL = "/rantion-bus";
import http, { updateResponse } from "@/http";
export function request(body: defs.bus.RequestDto, options?: any) {
  return updateResponse(
    http(URL + `/bus/executeExchange`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
